import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Translation } from 'react-i18next';
import MenuEmptyPlaceholder from 'components/dashboard/menu-links-content/MenuEmptyPlaceholder';
import {
  fetchMenuLinksList,
  clearCreateMenuLink,
  clearDeleteMenuLink,
  clearPatchMenusItem,
  clearCreateMenusItem,
  clearDeleteMenusItem,
  applyMenuLinkDrag,
  clearMenuLinkDrag,
} from 'redux/menu-links/actions';
import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { resetLastPatchedId } from 'redux/common/actions';
import { Link } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import MenuLinkItem from '../MenuLinkItem';
import CommonMessage from 'components/common/CommonMessage';
import { connect } from 'react-redux';

class MenuLinkList extends Component {
  static propTypes = {
    me: PropTypes.object,
    menuLinksList: PropTypes.arrayOf(PropTypes.object),
    menuLinksListError: PropTypes.object,
    createMenuLinkSuccess: PropTypes.object,
    patchMenuLinkSuccess: PropTypes.object,
    deleteMenuLinkSuccess: PropTypes.object,
    patchMenusItemSuccess: PropTypes.object,
    clearPatchMenusItem: PropTypes.func.isRequired,
    createMenusItemSuccess: PropTypes.object,
    clearCreateMenusItem: PropTypes.func.isRequired,
    deleteMenusItemSuccess: PropTypes.object,
    fetchMenuLinksList: PropTypes.func.isRequired,
    clearCreateMenuLink: PropTypes.func.isRequired,
    clearDeleteMenuLink: PropTypes.func.isRequired,
    clearPatchMenusItem: PropTypes.func.isRequired,
    clearCreateMenusItem: PropTypes.func.isRequired,
    clearDeleteMenusItem: PropTypes.func.isRequired,
    applyMenuLinkDrag: PropTypes.func.isRequired,
    clearMenuLinkDrag: PropTypes.func.isRequired,
  }

  static defaultProps = {
    me: null,
    menuLinksList: null,
    menuLinksListError: null,
    createMenuLinkSuccess: null,
    patchMenuLinkSuccess: null,
    deleteMenuLinkSuccess: null,
    patchMenusItemSuccess: null,
    clearPatchMenusItem: null,
    createMenusItemSuccess: null,
    clearCreateMenusItem: null,
    deleteMenusItemSuccess: null,
  };

  
  componentDidUpdate(prevProps) {
    
    // Set Current List
    if (prevProps.menuLinksList !== this.props.menuLinksList) {
      this.setState({ items: this.props.menuLinksList });
    }

    // Patch Link
    if (
      !prevProps.patchMenusItemSuccess &&
      prevProps.patchMenusItemSuccess !== this.props.patchMenusItemSuccess
    ) {
      this.props.fetchMenuLinksList();
      this.props.clearPatchMenusItem();
    }

    //Create new Menus Item
    if (
      !prevProps.createMenusItemSuccess &&
      prevProps.createMenusItemSuccess !== this.props.createMenusItemSuccess
    ) {
      this.props.fetchMenuLinksList();
      this.props.clearCreateMenusItem();
    }

     // Delete Menus Item
     if (
      !prevProps.deleteMenusItemSuccess &&
      prevProps.deleteMenusItemSuccess !== this.props.deleteMenusItemSuccess
    ) {
      this.props.fetchMenuLinksList();
      this.props.clearDeleteMenusItem();
    }

    // Delete Link
    if (
      !prevProps.deleteMenuLinkSuccess &&
      prevProps.deleteMenuLinkSuccess !== this.props.deleteMenuLinkSuccess
    ) {
      this.props.fetchMenuLinksList();
      this.props.clearDeleteMenuLink();
    }

    // Drag Link
    if (
      !prevProps.menuLinkDrugSuccess &&
      prevProps.menuLinkDrugSuccess !== this.props.menuLinkDrugSuccess
    ) {
      this.props.fetchMenuLinksList();
      this.props.clearMenuLinkDrag();
    }
  }

  componentWillUnmount() {
    this.props.resetLastPatchedId();
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    const { menuLinksList } = this.props;
    if (!result.destination) {
      return;
    }

    const newList = this.reorder(
      menuLinksList,
      result.source.index,
      result.destination.index
    );

    const form = new FormData();
    newList.map(item => item.id)
      .forEach(item => form.append('order', item));
    this.props.applyMenuLinkDrag(form);
    
  };

  renderMenuLinksList = () => {
    const { menuLinksList } = this.props;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {menuLinksList  && menuLinksList.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      className="list-wrapper"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <MenuLinkItem 
                        key={`menu-link-item-${item.id}`} 
                        item={item} 
                      />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { me, menuLinksList, menuLinksListError } = this.props;
    const isPro = me && me.subscription && me.subscription.ff_menu;

    return (
      <Translation>
        {(t) => (
          <div className="menu-links-list__component">
            {!menuLinksList && !menuLinksListError && <Loader active />}

            {/* Links List */}
            {
              this.renderMenuLinksList()
            }

            {/* List Error */}
            {menuLinksListError && 
              <CommonMessage error errors={menuLinksListError} />
            }

            {/* Empty Placeholder */}
            {menuLinksList && menuLinksList.length === 0 && (
              <MenuEmptyPlaceholder />
            )}

            {/* Undertext */}

            {!isPro && (
              <div className="undertext">
                {t("You can add multiple menus & price lists on the PRO plan.")} {t("Check it")} <Link to ="/billing">{t("here")}</Link>
              </div>
            )}
            {isPro && (
              <div className="undertext">
                {t("You are PRO! You can add multiple menus & price lists")}
              </div>
            )}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    menuLinksList: state.menuLinksReducer.menuLinksList,
    menuLinksListError: state.menuLinksReducer.menuLinksListError,
    createMenuLinkSuccess: state.menuLinksReducer.createMenuLinkSuccess,
    patchMenuLinkSuccess: state.menuLinksReducer.patchMenuLinkSuccess,
    deleteMenuLinkSuccess: state.menuLinksReducer.deleteMenuLinkSuccess,
    patchMenusItemSuccess: state.menuLinksReducer.patchMenusItemSuccess,
    createMenusItemSuccess: state.menuLinksReducer.createMenusItemSuccess,
    deleteMenusItemSuccess: state.menuLinksReducer.deleteMenusItemSuccess,
    menuLinkDrugSuccess: state.menuLinksReducer.menuLinkDrugSuccess,
  }
);

export default connect(mapStateToProps, {
  fetchMenuLinksList,
  clearCreateMenuLink,
  clearDeleteMenuLink,
  clearPatchMenusItem,
  clearCreateMenusItem,
  clearDeleteMenusItem,
  resetLastPatchedId,
  applyMenuLinkDrag,
  clearMenuLinkDrag,
})(MenuLinkList);
